module.exports = __webpack_public_path__ + "static/media/stv.4b92d503.mp3";